// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AndroidFilledSvg from "@fishx/icons-svg/es/asn/AndroidFilled";
import FishxIcon from '../components/FishxIcon';

var AndroidFilled = function AndroidFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AndroidFilledSvg
  }));
};

AndroidFilled.displayName = 'AndroidFilled';
export default React.forwardRef(AndroidFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AndroidFilled.js
// module id = 1981
// module chunks = 0